import { Component, DestroyRef, effect, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AssetTemplate } from '@iot-platform/models/i4b';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { finalize } from 'rxjs/operators';
import { CustomCellParams } from '../../../models/custom-cell.params';
import { AssetTemplateCellService } from './asset-template-cell.service';

@Component({
  imports: [MatProgressSpinner, InfoDisplayPipe],
  providers: [InfoDisplayPipe],
  selector: 'grid-engine-asset-template-cell',
  templateUrl: './asset-template-cell.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./asset-template-cell.component.scss']
})
export class AssetTemplateCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<CustomCellParams> = signal(null);
  templateLoading: WritableSignal<boolean> = signal(false);
  assetTemplate: WritableSignal<AssetTemplate> = signal(null);
  destroyRef: DestroyRef = inject(DestroyRef);
  private readonly assetTemplateCellService: AssetTemplateCellService = inject(AssetTemplateCellService);

  constructor() {
    effect(() => {
      const params = this.params();
      if (!!params?.value) {
        this.templateLoading.set(true);
        this.assetTemplateCellService
          .getAssetTemplateById(params.value)
          .pipe(
            finalize(() => this.templateLoading.set(false)),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe((template: AssetTemplate) => {
            this.assetTemplate.set(template);
          });
      }
    });
  }

  agInit(params: CustomCellParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
